module.exports = __webpack_public_path__ + "img/heart_8.a664a58d.png";